<div class="flex flex-col justify-between">
  <div class="flex-1">
    <h3>{{ dialogData.action || 'Delete' }} {{ dialogData.name }}</h3>

    @if (dialogData.list && dialogData.list.length > 0) {
      <ul>
        @for (item of dialogData.list; track item) {
          <li>{{ item }}</li>
        }
      </ul>
    }

    <p data-testid="confirmation-message" class="strong text-night">
      Are you sure you want to {{ (dialogData.action | lowercase) || 'delete' }} {{ dialogData.name
      }}{{ identifier() }}?
    </p>

    @if (dialogData.additionalText) {
      <div class="additionalText" [innerHTML]="dialogData.additionalText"></div>
    }
  </div>

  <div class="flex items-center justify-end gap-2 mt-4">
    <ui-button [label]="'Cancel'" [variant]="'tertiary'" (onClick)="cancelClicked()"> </ui-button>
    <ui-button [label]="dialogData.action || 'Delete'" [variant]="'destructive'" (onClick)="okClicked()"> </ui-button>
  </div>
</div>
